const STORAGE_KEY = 'thalamus_gestao_entregas_reuniao_vinculo'

function extrairEmailsConvidados(entregas = []) {
    const set = new Set()
    for (const entrega of entregas) {
        const coordenadorEmail = String(entrega?.coordenador_email || '').trim().toLowerCase()
        const gerenteEmail = String(entrega?.gerente_email || '').trim().toLowerCase()
        if (coordenadorEmail) set.add(coordenadorEmail)
        if (gerenteEmail) set.add(gerenteEmail)
    }
    return [...set]
}

function resumoEntregas(entregas = []) {
    if (!Array.isArray(entregas) || entregas.length === 0) return 'Sem entregas listadas.'
    return entregas
        .map((entrega, idx) => {
            const nomeProjeto = entrega?.projeto_nome || 'Projeto'
            const nomeEntrega = entrega?.entrega_nome || 'Pacote de trabalho'
            const fim = entrega?.fim_previsto || 'sem data'
            return `${idx + 1}. ${nomeProjeto} - ${nomeEntrega} (fim: ${fim})`
        })
        .join('\n')
}

export function montarPayloadCriarReuniaoGestao({ periodoInicio, periodoFim, entregas = [] }) {
    const emails = extrairEmailsConvidados(entregas)
    const titulo = 'Gestão de pacotes de trabalho - Reunião de acompanhamento'
    const descricao = [
        `Período considerado: ${periodoInicio || '-'} até ${periodoFim || '-'}`,
        `Total de entregas no período: ${entregas.length}`,
        '',
        resumoEntregas(entregas),
    ].join('\n')

    return {
        periodo_inicio: periodoInicio,
        periodo_fim: periodoFim,
        summary: titulo,
        description: descricao,
        emails_convidados: emails,
    }
}

export function lerVinculoReuniao() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        return typeof parsed === 'object' && parsed ? parsed : null
    } catch (_e) {
        return null
    }
}

export function salvarVinculoReuniao(payload = {}) {
    const vinculo = {
        v: 1,
        reuniaoGoogleId: Number(payload.reuniaoGoogleId),
        googleEventId: payload.googleEventId || null,
        htmlLink: payload.htmlLink || null,
        summary: payload.summary || null,
        periodoInicio: payload.periodoInicio || null,
        periodoFim: payload.periodoFim || null,
        criadaPelaTela: Boolean(payload.criadaPelaTela),
        vinculadoEm: new Date().toISOString(),
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(vinculo))
    return vinculo
}

export function limparVinculoReuniao() {
    window.localStorage.removeItem(STORAGE_KEY)
}

export function vinculoValidoParaPeriodo(periodoInicio, periodoFim, vinculo = lerVinculoReuniao()) {
    if (!vinculo) return false
    const reuniaoGoogleId = Number(vinculo.reuniaoGoogleId)
    if (!Number.isFinite(reuniaoGoogleId) || reuniaoGoogleId <= 0) return false
    return vinculo.periodoInicio === periodoInicio && vinculo.periodoFim === periodoFim
}
